import { types } from "../../types/types";

const initialState = {
  cfdiBilling: []
}

export const CfdiUsesBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.cfdiUseBillingStartLoading:
      return{
        ...state,
        cfdiBilling: [ ...action.payload ]
      }
      
    default:
      return state;
  }
}
